import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCoOwnership } from "@/components/Sections/CoOwnership/useCoOwnership";
import { Section, Title } from "@/components/UI";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
export const coOwnershipTestId = "cdp-co-ownership";
export const CoOwnership = () => {
    const features = useCoOwnership();
    const { t } = useI18n();
    if (!features.length)
        return null;
    return (_jsxs(Section, { testId: coOwnershipTestId, children: [_jsx(Title, { variant: "section", heading: "h2", title: t("coownership.headline") }), _jsx(Box, { as: "div", display: "flex", flexDirection: "column", gap: "spacing.12", children: features.map(({ type, label, value, icon }) => (_jsxs(Box, { as: "div", display: "flex", gap: "spacing.12", children: [_jsx(Box, { as: "span", children: icon }), _jsxs(Box, { as: "div", display: "flex", flexDirection: "column", children: [_jsx(Box, { as: "span", typography: "typography.body.16.bold", children: label }), _jsx(Box, { as: "span", typography: "typography.body.16.regular", children: value })] })] }, type))) })] }));
};
